import {Box, Stack, Typography} from '@mui/material';
import {type PlanSettings} from 'client/';
import {NumericField} from 'components/Generic/NumericField';
import {useTranslation} from 'react-i18next';

export const PlanSettingsNOKtoUSD = ({
  setPlanSettings,
  planSettings,
}: {
  setPlanSettings: React.Dispatch<React.SetStateAction<PlanSettings | undefined>>;
  planSettings: PlanSettings | undefined;
}) => {
  const {t} = useTranslation('common');
  return (
    <Stack direction={'row'} justifyContent="space-between" alignItems="flex-start" width="100%">
      <Stack spacing={1}>
        <Typography variant="h6">{t('planSettingsNOKtoUSD')}</Typography>
        <Typography variant="caption" color="text.disabled">
          {t('planSettingsNOKtoUSDCaption')}
        </Typography>
      </Stack>
      <Box display="flex" justifyContent="flex-end" minWidth={200}>
        <NumericField
          handleChange={({target: {value}}) => {
            planSettings && setPlanSettings({...planSettings, nokToUsdExchangeRate: parseFloat(value)});
          }}
          onKeyPress={() => {}}
          value={planSettings?.nokToUsdExchangeRate}
          fieldName="nokToUsdExchangeRate"
          helperText="nokToUsdExchangeRateHelperText"
          endAdornment="USD/NOK"
        />
      </Box>
    </Stack>
  );
};
